import * as React from 'react';

function SvgBfpSetting(props) {
  return (
    <svg viewBox="0 0 254 175" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M158.356 111.167h36.679c8.64 0 15.709 7.068 15.709 15.708V174h-52.388v-62.833z"
        fill="#FFF1F0"
        stroke="#FFA39E"
        strokeWidth={1.64}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M121.757 79.75h20.97c8.639 0 15.708 7.069 15.708 15.708V174h-52.387V95.458c0-8.639 6.99-15.708 15.709-15.708zm-52.39 54.979h36.68V174H53.66v-23.562c0-8.64 7.068-15.709 15.708-15.709z"
        fill="#FFF1F0"
        stroke="#FFA39E"
        strokeWidth={1.64}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.161 20.23l-4.119 8.237c-.543 1.165-2.02 2.253-3.263 2.409l-7.461 1.243c-4.74.777-5.906 4.274-2.487 7.616l5.829 5.828c1.01 1.01 1.554 2.875 1.243 4.197l-1.632 7.15c-1.321 5.672 1.71 7.848 6.683 4.895l6.994-4.118c1.244-.778 3.342-.778 4.585 0l6.995 4.118c4.973 2.953 8.004.777 6.683-4.896l-1.632-7.15c-.311-1.32.233-3.263 1.243-4.196l5.751-5.75c3.419-3.42 2.331-6.839-2.487-7.616l-7.46-1.243c-1.244-.234-2.72-1.322-3.264-2.41l-4.119-8.237c-2.253-4.508-5.828-4.507-8.082-.078zM184.909 68.471l-2.503 5.007c-.331.708-1.228 1.37-1.984 1.464l-4.534.755c-2.881.473-3.589 2.598-1.511 4.629l3.542 3.542c.614.614.945 1.747.756 2.55l-.992 4.345c-.803 3.448 1.039 4.77 4.062 2.975l4.25-2.503c.756-.472 2.031-.472 2.787 0l4.25 2.503c3.023 1.795 4.864.473 4.062-2.975l-.992-4.345c-.189-.803.141-1.984.755-2.55l3.495-3.495c2.078-2.078 1.417-4.156-1.511-4.629l-4.534-.755c-.756-.142-1.653-.803-1.983-1.464l-2.503-5.006c-1.37-2.74-3.542-2.74-4.912-.048zM77.472 92.235l-2.503 5.007c-.331.708-1.228 1.37-1.984 1.463l-4.534.756c-2.88.473-3.59 2.598-1.511 4.629l3.542 3.542c.614.614.945 1.747.755 2.55l-.991 4.345c-.803 3.447 1.039 4.77 4.062 2.975l4.25-2.503c.755-.472 2.03-.472 2.786 0l4.251 2.503c3.022 1.795 4.864.472 4.061-2.975l-.991-4.345c-.19-.803.141-1.984.755-2.55l3.495-3.495c2.078-2.078 1.417-4.156-1.511-4.629l-4.534-.755c-.756-.142-1.653-.803-1.984-1.464l-2.503-5.006c-1.37-2.74-3.542-2.74-4.911-.048z"
        fill="#FFCCC7"
      />
      <path
        opacity={0.5}
        d="M234.938 81.75c-5.71 2.833-13.289-.81-13.289-.81s1.685-8.232 7.398-11.06c5.71-2.833 13.286.805 13.286.805s-1.684 8.233-7.395 11.065zM24.244 122.924c5.257 3.151 12.8.238 12.8.238s-.987-8.02-6.247-11.167c-5.258-3.151-12.797-.242-12.797-.242s.986 8.02 6.244 11.171z"
        fill="#FFCCC7"
      />
      <path
        d="M198.045 37.055a6.913 6.913 0 100 13.826 6.913 6.913 0 000-13.826zM35.194 68.62a5.69 5.69 0 100 11.382 5.69 5.69 0 000-11.382zM86.321 50.822a6.48 6.48 0 110-12.96 6.48 6.48 0 010 12.96z"
        fill="#FFCCC7"
      />
      <path
        opacity={0.5}
        d="M250.018 104.326a3.024 3.024 0 11-.001-6.049 3.024 3.024 0 01.001 6.049zM4.243 162.04a3.888 3.888 0 11-.002-7.775 3.888 3.888 0 01.002 7.775zM226.899 37.7a4.753 4.753 0 110-9.506 4.753 4.753 0 010 9.505zM67.52 3.553a1.776 1.776 0 110-3.553 1.776 1.776 0 010 3.553zM242.499 160.515c-2.412 0-4.367-1.564-4.367-3.493 0-1.93 1.955-3.494 4.367-3.494s4.367 1.564 4.367 3.494c0 1.929-1.955 3.493-4.367 3.493zM178.164 6.61a3.09 3.09 0 11-5.968 1.598 3.09 3.09 0 015.968-1.599zM42.2 24.972h.063c.368 5.22 4.25 5.3 4.25 5.3s-4.28.084-4.28 6.115c0-6.031-4.281-6.115-4.281-6.115s3.88-.08 4.248-5.3zM32.2 134.972h.063c.368 5.22 4.25 5.3 4.25 5.3s-4.28.084-4.28 6.115c0-6.031-4.281-6.115-4.281-6.115s3.88-.08 4.248-5.3zM230.2 113.972h.063c.368 5.22 4.25 5.3 4.25 5.3s-4.28.084-4.28 6.115c0-6.031-4.281-6.115-4.281-6.115s3.88-.08 4.248-5.3z"
        fill="#FFCCC7"
      />
    </svg>
  );
}

export default SvgBfpSetting;
